module.exports = __webpack_public_path__ + "static/media/compass_rose_2.70bd21d1.png";